export function stringifyEscapeQuotes(element: any): string {
  return JSON.stringify(element).replace(/'/g, "&apos;");
}
